export const PERIOD_OPTIONS = [
  { value: 'today', label: 'اليوم' },
  { value: 'yesterday', label: 'أمس' },
  { value: 'last_7_days', label: 'آخر 7 أيام' },
  { value: 'this_week', label: 'هذا الأسبوع' },
  { value: 'this_month', label: 'هذا الشهر' },
  { value: 'last_90_days', label: 'آخر 90 يوم' },
  { value: 'custom', label: 'مخصص' },
  { value: 'all', label: 'الكل' },
];
